/* global HOUSECALL_CHAT_URL */
/* eslint-disable no-await-in-loop */
import { LocalStorage } from '../../components/Common/Utils/local_storage';
import { SB_KEY } from './Data';
import getStoredToken from './getStoredToken';
import refreshToken from './refreshToken';

const MAX_RETRY_COUNT = 3;

async function getUnreadMessages(proId) {
  let lastError = null;
  for (let i = 0; i < MAX_RETRY_COUNT; i += 1) {
    try {
      const token = getStoredToken() || (await refreshToken());
      const result = await fetch(`${HOUSECALL_CHAT_URL}/api/unread_messages?token=${token || ''}&user=${proId || ''}`);
      const data = await result.json();
      if (!result.ok && [400302, 400401].includes(data?.code)) {
        LocalStorage.removeItem(SB_KEY);
        throw new Error('Invalid Token');
      } else {
        const { unread_messages: unreadMessages } = data;
        return unreadMessages || 0;
      }
    } catch (error) {
      lastError = error;
    }
  }
  throw lastError;
}

export default getUnreadMessages;
